"use client";

import { cn } from "@/lib/utils";
import type { ServiceFilter } from "@/types/location";
import CustomButton from "@/components/ui/custom-button";

interface CategoryFilterBarProps {
  filters: ServiceFilter[];
  activeFilter: string;
  onFilterChange: (filter: string) => void;
  className?: string;
}

export function CategoryFilterBar({
  filters,
  activeFilter,
  onFilterChange,
  className,
}: CategoryFilterBarProps) {
  return (
    <div className={cn("flex flex-wrap justify-center gap-4 mb-12", className)}>
      {filters.map((filter) => (
        <CustomButton
          key={filter.id}
          variant={activeFilter === filter.slug ? "default" : "outline"}
          onClick={() => onFilterChange(filter.slug)}
          className={cn(
            "rounded-full px-6 py-2",
            activeFilter === filter.slug
              ? "bg-yellow-500 text-black hover:bg-yellow-600"
              : "border-zinc-700 text-white hover:bg-zinc-800 hover:text-white"
          )}
        >
          {filter.name}
        </CustomButton>
      ))}
    </div>
  );
}
